module.exports = __webpack_public_path__ + "static/img/20250324185121.375f722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20250324185121.png
// module id = VVcM
// module chunks = 1